import styled from 'styled-components';

export const Container = styled.div`
  cursor: pointer;
  transform: translate(0px, 0px);

  p {
    visibility: hidden;
    opacity: 0;
    transform: translateY(20px);
    transition: 300ms !important;
    position: fixed;
    white-space: nowrap;
    right: 0px;
    bottom: calc(100% + 1rem);
    background: ${(props) => props.theme.colors.palet.institutional7};
    color: ${(props) => props.theme.colors.text.inverse};
    font-family: 'Unimed-Sans-SemiBold';
    font-size: 1rem;
    padding: 6px 20px;
    border-radius: 10px;
    box-shadow: 0px 4px 4px rgba(255, 15, 100, 0.3);

    &::before {
      content: '';
      position: absolute;
      bottom: -10px;
      right: 8px;
      border: 5px solid ${(props) => props.theme.colors.palet.institutional7};
      border-left-color: transparent;
      border-bottom-color: transparent;
    }

    @media (max-width: 768px) {
      max-width: calc(100vw - 5rem);
      width: max-content;
      white-space: normal;
    }
  }

  &:hover {
    p {
      transition: 300ms;
      visibility: visible;
      opacity: 1;
      transform: translateY(0);
    }
  }
`;
